const DB_NAME = 'mobile_orders_reference_db'
const DB_VERSION = 1
const STORE_BLOCKS = 'reference_blocks'

let dbPromise = null

function blockKey(sellerId, block) {
  return `${String(sellerId)}|${block}`
}

function openDb() {
  if (dbPromise) return dbPromise

  dbPromise = new Promise((resolve, reject) => {
    if (typeof indexedDB === 'undefined') {
      reject(new Error('IndexedDB no disponible'))
      return
    }

    const request = indexedDB.open(DB_NAME, DB_VERSION)

    request.onupgradeneeded = event => {
      const db = event.target.result
      if (!db.objectStoreNames.contains(STORE_BLOCKS)) {
        db.createObjectStore(STORE_BLOCKS, { keyPath: 'key' })
      }
    }

    request.onsuccess = event => {
      const db = event.target.result
      db.onversionchange = () => {
        db.close()
        dbPromise = null
      }
      resolve(db)
    }
    request.onerror = () => {
      dbPromise = null
      reject(request.error || new Error('No se pudo abrir IndexedDB'))
    }
    request.onblocked = () => {
      dbPromise = null
      reject(new Error('La actualización de IndexedDB está bloqueada'))
    }
  })

  return dbPromise
}

function requestToPromise(request) {
  return new Promise((resolve, reject) => {
    request.onsuccess = () => resolve(request.result)
    request.onerror = () => reject(request.error || new Error('Operación IndexedDB fallida'))
  })
}

function transactionToPromise(transaction) {
  return new Promise((resolve, reject) => {
    transaction.oncomplete = () => resolve(true)
    transaction.onabort = () => reject(transaction.error || new Error('Transacción IndexedDB cancelada'))
    transaction.onerror = () => reject(transaction.error || new Error('Transacción IndexedDB fallida'))
  })
}

const ReferenceStorage = {
  async replaceBlock(sellerId, block, data) {
    if (sellerId === null || sellerId === undefined || !block || !Array.isArray(data)) return false

    try {
      const db = await openDb()
      const transaction = db.transaction(STORE_BLOCKS, 'readwrite')
      const completion = transactionToPromise(transaction)
      transaction.objectStore(STORE_BLOCKS).put({
        key: blockKey(sellerId, block),
        sellerId: String(sellerId),
        block,
        data,
        updatedAt: Date.now(),
      })
      await completion
      return true
    } catch (error) {
      console.warn(`[ReferenceStorage] No se pudo guardar ${block}:`, error)
      return false
    }
  },

  async getBlock(sellerId, block) {
    if (sellerId === null || sellerId === undefined || !block) return null

    try {
      const db = await openDb()
      const transaction = db.transaction(STORE_BLOCKS, 'readonly')
      const record = await requestToPromise(
        transaction.objectStore(STORE_BLOCKS).get(blockKey(sellerId, block))
      )
      return record && Array.isArray(record.data) ? record.data : null
    } catch (error) {
      console.warn(`[ReferenceStorage] No se pudo leer ${block}:`, error)
      return null
    }
  },
}

export default ReferenceStorage
